import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { LmsService } from "../../_Lms/services/lms.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { CommonFunctions } from "../../CommonComponent/function/commonfunctions";
import { MasterService } from "../../Shared/app.Masters.Service";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";

declare var $: any;

@Component({
  selector: "app-multiple-voucher-import-summary",
  templateUrl: "./multiple-voucher-import-summary.component.html",
  styleUrls: ["./multiple-voucher-import-summary.component.scss"],
  standalone: false,
})
export class MultipleVoucherImportSummaryComponent implements OnInit {
  EmployeeDropdown: any[] = [];
  EmployeeId: any = "";
  FyearId: any = 0;
  showSpinner: boolean = false;
  SummaryList: any[] = [];
  dataSource: any;
  displayedColumns: string[] = [
    "SrNo",
    "Batch_no",
    "Voucher_CreateBy",
    "VoucherIdCount",
    "Voucher_CreateOn",
    "Action",
  ];

  // Voucher Details Modal properties
  showDetailsModal: boolean = false;
  batchSummaryHeader: any = {};
  voucherDetailsList: any[] = [];
  detailsDataSource: any;
  displayedLoanColumns: string[] = [
    "Type",
    "CaseNo",
    "Customer",
    "Branch",
    "Category",
    "AccountHead",
    "AmountDR",
    "AmountCR",
  ];
  Remark: string = "";
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private _MasterService: MasterService,
    private lmsService: LmsService,
    private route: ActivatedRoute,
    private _Route: Router,
    private _commonfunctions: CommonFunctions,
    private dataSharingService: DataSharingService,
    private dialog: DialogService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.initFyear();
    this.GetEmployeeDropdown();
    this.dataSharingService.HeaderTitle.next("Multiple Voucher Import Summary");
  }

  initFyear(): void {
    this.route.queryParams.subscribe((params) => {
      if (params["fyear"]) {
        this.FyearId = parseInt(params["fyear"], 10);
      } else {
        this.updateFyearFromSessionOrApi();
      }
    });
    this.updateFyearFromSessionOrApi();
  }

  updateFyearFromSessionOrApi(): void {
    const sessionFyear = sessionStorage.getItem("FyearId");
    if (sessionFyear && parseInt(JSON.parse(sessionFyear), 10) > 0) {
      this.FyearId = parseInt(JSON.parse(sessionFyear), 10);
    } else {
      this.lmsService.Get_FinancialYear({ Id: 0 }).subscribe((res: any) => {
        if (res && res.length > 0) {
          this.FyearId = res[res.length - 1].Id;
        }
      });
    }
  }

  getFyearId(): number {
    const queryParamFyear = this.route.snapshot.queryParams["fyear"];
    if (queryParamFyear && parseInt(queryParamFyear, 10) > 0) {
      return parseInt(queryParamFyear, 10);
    }
    const sessionFyear = sessionStorage.getItem("FyearId");
    if (sessionFyear && parseInt(JSON.parse(sessionFyear), 10) > 0) {
      return parseInt(JSON.parse(sessionFyear), 10);
    }
    return Number(this.FyearId) || 0;
  }

  GetEmployeeDropdown(): void {
    this._MasterService
      .GetEmployeeDropdown({ BranchId: 0, ProcessId: 0 })
      .subscribe({
        next: (result: any) => {
          this.EmployeeDropdown = result || [];
        },
        error: (err: any) => {
          console.error("Error fetching Employee Dropdown:", err);
        },
      });
  }

  onSearch(): void {
    this.showSpinner = true;
    const empIdNum = this.EmployeeId ? Number(this.EmployeeId) : 0;
    const fyearIdNum = this.getFyearId();
    this.FyearId = fyearIdNum;

    const requestData = {
      EmpId: empIdNum,
      fyearId: fyearIdNum,
    };

    this._MasterService.MultipleVoucherImportSummary(requestData).subscribe({
      next: (res: any) => {
        this.showSpinner = false;
        let data = res;
        if (typeof res === "string") {
          try {
            data = JSON.parse(res);
          } catch (e) {
            data = res;
          }
        }

        this.SummaryList = Array.isArray(data)
          ? data
          : data?.data || data?.List || data?.Table || [];
        this.dataSource = new MatTableDataSource(this.SummaryList);
        setTimeout(() => {
          if (this.paginator) this.dataSource.paginator = this.paginator;
          if (this.sort) this.dataSource.sort = this.sort;
        });
      },
      error: (err: any) => {
        this.showSpinner = false;
        console.error("Error fetching MultipleVoucherImportSummary:", err);
      },
    });
  }

  onClear(): void {
    this.EmployeeId = "";
    this.SummaryList = [];
    this.dataSource = null;
  }

  applyFilter(filterValue: string): void {
    if (this.dataSource) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  formatDateOnly(dateVal: any): string {
    if (!dateVal) return "";
    const str = String(dateVal).trim();
    if (str.includes(" ")) {
      return str.split(" ")[0];
    }
    if (str.includes("T")) {
      return str.split("T")[0];
    }
    return str;
  }

  onAction(row: any): void {
    if (!row || !row.Batch_no) return;
    this.Remark = "";
    this.showSpinner = true;
    this._MasterService
      .MultipleVoucherImportDetails({ Batch_no: row.Batch_no })
      .subscribe({
        next: (res: any) => {
          this.showSpinner = false;
          let data = res;
          if (typeof res === "string") {
            try {
              data = JSON.parse(res);
            } catch (e) {
              data = res;
            }
          }

          const headerObj =
            data?.Item1 && data.Item1.length > 0 ? data.Item1[0] : {};
          this.batchSummaryHeader = {
            ...row,
            ...headerObj,
            Voucher_No: headerObj.Voucher_No || row.Batch_no,
            Voucher_Date: headerObj.Voucher_Date || row.Voucher_CreateOn,
          };

          let detailsRaw: any[] = data?.Item2 || [];

          // Helper to extract voucher identifier across all possible property names
          const getVoucherKey = (item: any): string => {
            if (!item) return "";
            const candidates = [
              item.VoucherId,
              item.Voucher_Id,
              item.VoucherNo,
              item.Voucher_No,
              item.VoucherID,
              item.voucherId,
              item.voucher_id,
              item.Voucher_no,
              item.voucherNo,
              item.voucher_No,
              item.Bind_Voucher,
              item.Voucher,
            ];
            for (const c of candidates) {
              if (c !== undefined && c !== null) {
                const s = String(c).trim();
                if (s.length > 0 && s !== "0") {
                  return s;
                }
              }
            }
            return "";
          };

          // Parse batch voucher order if available from row or header
          const rawVoucherIds =
            (row && (row.VoucherIds || row.Voucher_Ids || row.VoucherId)) ||
            (this.batchSummaryHeader &&
              (this.batchSummaryHeader.VoucherIds ||
                this.batchSummaryHeader.Voucher_Ids ||
                this.batchSummaryHeader.VoucherId)) ||
            (headerObj &&
              (headerObj.VoucherIds ||
                headerObj.Voucher_Ids ||
                headerObj.VoucherId)) ||
            "";

          const batchVoucherOrder: string[] = String(rawVoucherIds)
            .split(",")
            .map((id: string) => id.trim())
            .filter((id: string) => id.length > 0);

          // Helper to get order for TranType (DR must come first, CR second)
          const getTranTypeRank = (tranType: any): number => {
            const t = String(tranType || "")
              .trim()
              .toUpperCase();
            if (t === "DR") return 1;
            if (t === "CR") return 2;
            return 3;
          };

          // Group all rows by voucher key so same voucher entries can never be separated
          const groupsMap = new Map<
            string,
            { key: string; items: any[]; firstIndex: number }
          >();
          const unassigned: any[] = [];

          detailsRaw.forEach((item: any, originalIndex: number) => {
            const key = getVoucherKey(item);
            if (key) {
              if (!groupsMap.has(key)) {
                groupsMap.set(key, {
                  key,
                  items: [],
                  firstIndex: originalIndex,
                });
              }
              groupsMap.get(key)!.items.push(item);
            } else {
              unassigned.push(item);
            }
          });

          // Sort within each group: DR first, then CR, then by Id
          groupsMap.forEach((group) => {
            group.items.sort((a: any, b: any) => {
              const rankA = getTranTypeRank(a.TranType);
              const rankB = getTranTypeRank(b.TranType);
              if (rankA !== rankB) return rankA - rankB;
              return (Number(a.Id) || 0) - (Number(b.Id) || 0);
            });
          });

          // Sort groups themselves:
          // 1. If batchVoucherOrder has keys, use that order
          // 2. Else by numeric key if numeric
          // 3. Else by original order of appearance
          const sortedGroups = Array.from(groupsMap.values());
          sortedGroups.sort((gA, gB) => {
            if (batchVoucherOrder.length > 0) {
              const idxA = batchVoucherOrder.indexOf(gA.key);
              const idxB = batchVoucherOrder.indexOf(gB.key);
              if (idxA !== -1 && idxB !== -1) return idxA - idxB;
              if (idxA !== -1) return -1;
              if (idxB !== -1) return 1;
            }

            const numA = Number(gA.key);
            const numB = Number(gB.key);
            if (!isNaN(numA) && !isNaN(numB)) {
              return numA - numB;
            }
            return gA.firstIndex - gB.firstIndex;
          });

          // Build final details list with per-group subtotals
          const finalDetailsList: any[] = [];
          let groupIndex = -1;

          sortedGroups.forEach((g) => {
            if (!g.items || g.items.length === 0) return;
            groupIndex++;
            const groupClass =
              groupIndex % 2 === 0 ? "voucher-group-even" : "voucher-group-odd";

            let groupSumDR = 0;
            let groupSumCR = 0;

            g.items.forEach((item: any) => {
              const tType = String(item.TranType || "")
                .trim()
                .toUpperCase();
              const rawAmt = Number(item.Amount) || 0;
              const amountDR =
                tType === "DR" ? rawAmt : Number(item.AmountDR) || 0;
              const amountCR =
                tType === "CR" ? rawAmt : Number(item.AmountCR) || 0;

              groupSumDR += amountDR;
              groupSumCR += amountCR;

              finalDetailsList.push({
                ...item,
                isGroupTotal: false,
                CaseNo: item.CaseNo || "-",
                Customer: item.Customer || "-",
                Branch_Name: item.Branch_Name || "-",
                ChagesHead: item.ChagesHead || item.ChargeHeadCategory || "-",
                Account_Name:
                  item.Account_Name || item.ChargeHeadCategory || "-",
                AmountDR: amountDR,
                AmountCR: amountCR,
                groupClass: groupClass,
              });
            });

            const rawGroupVoucherDate =
              g.items[0]?.Voucher_Date ||
              g.items[0]?.VoucherDate ||
              g.items[0]?.Voucher_CreateOn ||
              g.items[0]?.Date ||
              this.batchSummaryHeader?.Voucher_Date ||
              this.batchSummaryHeader?.Voucher_CreateOn ||
              "";

            const groupVoucherDate = this.formatDateOnly(rawGroupVoucherDate);

            // Insert subtotal row for this group
            finalDetailsList.push({
              isGroupTotal: true,
              Voucher_No: "",
              TranType: "",
              CaseNo: "",
              Customer: "",
              Branch_Name: "",
              ChagesHead: "",
              Account_Name: "Total",
              Voucher_Date: groupVoucherDate,
              AmountDR: groupSumDR,
              AmountCR: groupSumCR,
              groupClass: "voucher-group-subtotal-row",
            });
          });

          if (unassigned.length > 0) {
            groupIndex++;
            const groupClass =
              groupIndex % 2 === 0 ? "voucher-group-even" : "voucher-group-odd";

            let groupSumDR = 0;
            let groupSumCR = 0;

            unassigned.forEach((item: any) => {
              const tType = String(item.TranType || "")
                .trim()
                .toUpperCase();
              const rawAmt = Number(item.Amount) || 0;
              const amountDR =
                tType === "DR" ? rawAmt : Number(item.AmountDR) || 0;
              const amountCR =
                tType === "CR" ? rawAmt : Number(item.AmountCR) || 0;

              groupSumDR += amountDR;
              groupSumCR += amountCR;

              finalDetailsList.push({
                ...item,
                isGroupTotal: false,
                CaseNo: item.CaseNo || "-",
                Customer: item.Customer || "-",
                Branch_Name: item.Branch_Name || "-",
                ChagesHead: item.ChagesHead || item.ChargeHeadCategory || "-",
                Account_Name:
                  item.Account_Name || item.ChargeHeadCategory || "-",
                AmountDR: amountDR,
                AmountCR: amountCR,
                groupClass: groupClass,
              });
            });

            const rawUnassignedDate =
              unassigned[0]?.Voucher_Date ||
              unassigned[0]?.VoucherDate ||
              unassigned[0]?.Voucher_CreateOn ||
              unassigned[0]?.Date ||
              this.batchSummaryHeader?.Voucher_Date ||
              this.batchSummaryHeader?.Voucher_CreateOn ||
              "";

            const unassignedVoucherDate = this.formatDateOnly(rawUnassignedDate);

            finalDetailsList.push({
              isGroupTotal: true,
              Voucher_No: "",
              TranType: "",
              CaseNo: "",
              Customer: "",
              Branch_Name: "",
              ChagesHead: "",
              Account_Name: "Total",
              Voucher_Date: unassignedVoucherDate,
              AmountDR: groupSumDR,
              AmountCR: groupSumCR,
              groupClass: "voucher-group-subtotal-row",
            });
          }

          this.voucherDetailsList = finalDetailsList;

          this.detailsDataSource = new MatTableDataSource(
            this.voucherDetailsList,
          );
          this.showDetailsModal = true;
          setTimeout(() => {
            $("#VoucherDetailsModal").modal("show");
          });
        },
        error: (err: any) => {
          this.showSpinner = false;
          console.error("Error fetching MultipleVoucherImportDetails:", err);
        },
      });
  }
  onCloseDetailsModal(): void {
    $("#VoucherDetailsModal").modal("hide");
    this.showDetailsModal = false;
    this.Remark = "";
  }

  onDeleteBatch(): void {
    const batchNo =
      this.batchSummaryHeader?.Batch_no ||
      this.batchSummaryHeader?.Voucher_No ||
      "";
    if (!batchNo) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Invalid Batch Number",
        ...this.configSuccess,
      });
      return;
    }

    this.dialog
      .openConfirmDialog(
        "Are you sure you want to delete this batch? All vouchers in this batch will be deleted.",
      )
      .afterClosed()
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.showSpinner = true;
          const currentUser = JSON.parse(
            sessionStorage.getItem("currentUser") || "{}",
          );
          const loginUserId = currentUser.userId || currentUser.UserId || 0;

          const requestData = {
            BatchNo: batchNo,
            LoginUserId: loginUserId,
            Remark: this.Remark || "",
          };
          console.log("Request Data:", requestData);

          this._MasterService.Delete_Batch_ACC_Voucher(requestData).subscribe({
            next: (res: any) => {
              this.showSpinner = false;
              let msg = "Batch deleted successfully";
              if (res) {
                if (Array.isArray(res) && res.length > 0) {
                  msg = res[0].MSG || res[0].Msg || res[0].message || msg;
                } else if (typeof res === "object") {
                  msg = res.MSG || res.Msg || res.message || msg;
                } else if (typeof res === "string") {
                  try {
                    const parsed = JSON.parse(res);
                    if (Array.isArray(parsed) && parsed.length > 0) {
                      msg =
                        parsed[0].MSG ||
                        parsed[0].Msg ||
                        parsed[0].message ||
                        msg;
                    } else if (typeof parsed === "object") {
                      msg = parsed.MSG || parsed.Msg || parsed.message || msg;
                    } else {
                      msg = res;
                    }
                  } catch (e) {
                    msg = res;
                  }
                }
              }

              this.snackBar.openFromComponent(SnackbarComponent, {
                data: msg,
                ...this.configSuccess,
              });

              this.onCloseDetailsModal();
              this.onSearch();
            },
            error: (err: any) => {
              this.showSpinner = false;
              console.error("Error deleting batch voucher:", err);
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Error occurred while deleting batch voucher",
                ...this.configSuccess,
              });
            },
          });
        }
      });
  }

  calculateTotalDR(): number {
    if (!this.voucherDetailsList) return 0;
    return this.voucherDetailsList.reduce(
      (sum, item) => sum + (item.isGroupTotal ? 0 : Number(item.AmountDR) || 0),
      0,
    );
  }

  calculateTotalCR(): number {
    if (!this.voucherDetailsList) return 0;
    return this.voucherDetailsList.reduce(
      (sum, item) => sum + (item.isGroupTotal ? 0 : Number(item.AmountCR) || 0),
      0,
    );
  }

  PrintDoc(
    divName: string = "VoucherDetailPrint",
    Header: string = "Voucher Detail",
  ): void {
    const printElement = document.getElementById(divName);
    if (!printElement) return;

    const printContents = printElement.innerHTML;
    const popupWin = window.open("", "_blank", "width=1050,height=750");
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8">
            <title>${Header}</title>
            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css">
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
            <style>
              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                color-adjust: exact !important;
                box-sizing: border-box;
              }
              body {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
                margin: 0;
                padding: 16px;
                background-color: #f7f9fb !important;
                color: #1e293b;
                font-size: 11px;
              }
              /* Modal Wrapper in Print */
              .voucher-modal-content {
                background-color: #ffffff !important;
                border-radius: 8px !important;
                overflow: hidden !important;
                border: 1px solid #cbd5e1 !important;
                box-shadow: none !important;
              }
              .voucher-modal-header {
                background: linear-gradient(135deg, #0d3853 0%, #1e4d6b 100%) !important;
                background-color: #0d3853 !important;
                padding: 12px 18px !important;
                border: none !important;
                display: flex !important;
                align-items: center !important;
                justify-content: space-between !important;
              }
              .voucher-modal-header .modal-title {
                color: #ffffff !important;
                font-weight: 600 !important;
                font-size: 15px !important;
                margin: 0 !important;
                display: flex !important;
                align-items: center !important;
              }
              .voucher-modal-header .modal-title i {
                margin-right: 8px !important;
              }
              .voucher-modal-body {
                background-color: #f7f9fb !important;
                padding: 16px 20px !important;
              }

              /* Banner */
              .voucher-type-banner {
                background-color: #eaf1fa !important;
                border-left: 4px solid #0d3853 !important;
                border-radius: 6px;
                padding: 10px 14px;
                margin-bottom: 12px;
                display: flex !important;
                align-items: center !important;
                gap: 8px;
              }
              .voucher-type-label {
                font-size: 11px !important;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                color: #5b7186 !important;
                font-weight: 600 !important;
                margin-right: 6px;
              }
              .voucher-type-value {
                font-size: 13px !important;
                font-weight: 700 !important;
                color: #0d3853 !important;
              }

              /* Row & Cols */
              .row {
                display: flex !important;
                flex-wrap: wrap !important;
                margin-left: 0 !important;
                margin-right: 0 !important;
              }
              .col-md-12 {
                flex: 0 0 100% !important;
                max-width: 100% !important;
                width: 100% !important;
              }
              .col-md-3 {
                flex: 0 0 25% !important;
                max-width: 25% !important;
                width: 25% !important;
              }

              /* Meta Cards */
              .voucher-meta-row {
                margin-top: 4px;
                margin-bottom: 12px;
              }
              .voucher-meta-row > div {
                padding: 0 4px !important;
              }
              .voucher-meta-card {
                background-color: #ffffff !important;
                border: 1px solid #e3e9ef !important;
                border-radius: 6px;
                padding: 8px 12px;
                display: flex !important;
                flex-direction: column !important;
                gap: 2px;
                height: 100%;
              }
              .meta-label {
                font-size: 10px !important;
                color: #8a97a5 !important;
                text-transform: uppercase;
                letter-spacing: 0.4px;
                font-weight: 600 !important;
              }
              .meta-value {
                font-size: 12px !important;
                color: #1e293b !important;
                font-weight: 600 !important;
              }

              /* Table Wrapper & Table */
              .voucher-table-wrapper {
                border-radius: 8px;
                overflow: visible !important;
                max-height: none !important;
                border: 1px solid #e3e9ef !important;
                margin-top: 10px;
                margin-bottom: 12px;
              }
              table.voucher-table {
                width: 100% !important;
                border-collapse: collapse !important;
                margin: 0 !important;
                font-size: 11.5px !important;
              }
              table.voucher-table th, table.voucher-table td {
                padding: 8px !important;
                vertical-align: middle !important;
                border: 1px solid #edf1f5 !important;
              }
              table.voucher-table thead tr {
                background-color: #0d3853 !important;
              }
              table.voucher-table thead th {
                background-color: #0d3853 !important;
                color: #ffffff !important;
                font-weight: 600 !important;
                font-size: 11px !important;
                text-transform: uppercase;
                letter-spacing: 0.3px;
                border: none !important;
              }
              .voucher-group-even td {
                background-color: #eaf1fa !important;
              }
              .voucher-group-odd td {
                background-color: #eef5ef !important;
              }
              .voucher-group-subtotal-row td {
                background-color: #8cdcb8 !important;
                color: #0d3853 !important;
                font-weight: 700 !important;
                border-top: 1px solid #72ca9f !important;
                border-bottom: 1.5px solid #5eb98c !important;
                padding: 6px 8px !important;
              }
              tfoot .voucher-total-row td {
                background-color: #dce6f0 !important;
                color: #0d3853 !important;
                font-weight: 700 !important;
                padding: 10px 8px !important;
                border-top: 2px solid #0d3853 !important;
              }

              /* Type Badges */
              .type-badge {
                display: inline-block !important;
                min-width: 34px;
                padding: 2px 8px;
                border-radius: 10px;
                font-size: 10px !important;
                font-weight: 700 !important;
                letter-spacing: 0.3px;
                text-align: center;
              }
              .badge-dr {
                background-color: #fbe4e4 !important;
                color: #b23a3a !important;
              }
              .badge-cr {
                background-color: #e0f2e6 !important;
                color: #2e7d5b !important;
              }

              /* Amount Colors */
              .amount-dr {
                color: #b23a3a !important;
                font-weight: 500 !important;
              }
              .amount-cr {
                color: #2e7d5b !important;
                font-weight: 500 !important;
              }
              .fw-600 { font-weight: 600 !important; }
              .fw-700 { font-weight: 700 !important; }

              /* Narration & Footer Info */
              .voucher-footer-info {
                margin-top: 12px;
              }
              .voucher-footer-info .section-label {
                font-size: 10.5px !important;
                text-transform: uppercase;
                letter-spacing: 0.4px;
                color: #8a97a5 !important;
                font-weight: 600 !important;
                margin-bottom: 2px;
              }
              .voucher-footer-info .section-value {
                font-size: 12px !important;
                color: #1e293b !important;
                margin: 0;
              }
              .voucher-divider {
                border: 0;
                border-top: 1px solid #e3e9ef !important;
                margin: 8px 0 !important;
              }

              .p-0 { padding: 0 !important; }
              .p-1 { padding: 4px !important; }
              .p-2 { padding: 8px !important; }
              .m-0 { margin: 0 !important; }
              .mt-2 { margin-top: 8px !important; }
              .mt-3 { margin-top: 12px !important; }
              .text-left { text-align: left !important; }
              .text-center { text-align: center !important; }
              .text-right { text-align: right !important; }

              .no-print, .d-print-none, .btn, button, .voucher-close-btn, .close, .voucher-modal-footer {
                display: none !important;
              }

              @page {
                size: A4 portrait;
                margin: 8mm;
              }
            </style>
          </head>
          <body>
            ${printContents}
            <script>
              window.onload = function() {
                setTimeout(function() {
                  window.focus();
                  window.print();
                  window.close();
                }, 300);
              };
            </script>
          </body>
        </html>
      `);
      popupWin.document.close();
    }
  }
}
